"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setIsFocusedCapableService_1 = require("owa-mail-focused-inbox-config/lib/services/setIsFocusedCapableService");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var owa_mail_list_actions_1 = require("owa-mail-list-actions");
var updateAlwaysInCacheTableIds_1 = require("owa-mail-list-actions/lib/actions/helpers/tableCache/updateAlwaysInCacheTableIds");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_table_loading_actions_1 = require("owa-mail-table-loading-actions");
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var owa_session_store_1 = require("owa-session-store");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
var folderIdToName_1 = require("owa-session-store/lib/utils/folderIdToName");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Set Focused inbox On/Off
 * @param isFocusedInboxEnabled - Switch flag to indicate if Focused Inbox should be switched On/Off
 * @param skipServiceRequest - Whether to skip the service request to save the setting. Used when called as part of Options stitch
 */
exports.default = legacy_1.action('setFocusedInboxOnOff')(function setFocusedInboxOnOff(isFocusedInboxEnabled, skipServiceRequest) {
    var folderIdForSelectedNode = owa_mail_folder_forest_store_1.getFolderIdForSelectedNode();
    // Reload selected folder only if it is Inbox
    if (folderIdToName_1.default(folderIdForSelectedNode) === 'inbox') {
        var tableQuery = owa_mail_list_actions_1.createMailFolderTableQuery(folderIdForSelectedNode, owa_mail_list_store_1.getListViewTypeForFolder(folderIdForSelectedNode), isFocusedInboxEnabled ? 0 /* Focused */ : -1 /* None */, 'All');
        owa_mail_table_loading_actions_1.loadTableViewFromTableQuery(tableQuery);
    }
    if (!skipServiceRequest) {
        // update userOptions property and save the setting
        owa_session_store_1.getUserConfiguration().UserOptions.IsFocusedInboxEnabled = isFocusedInboxEnabled;
        updateUserConfiguration_1.default('OWA.UserOptions', [
            userConfigurationDictionaryEntry_1.default({
                DictionaryKey: userConfigurationDictionaryObject_1.default({
                    Type: 'String',
                    Value: ['IsFocusedInboxEnabled'],
                }),
                DictionaryValue: userConfigurationDictionaryObject_1.default({
                    Type: 'Boolean',
                    Value: [String(isFocusedInboxEnabled)],
                }),
            }),
        ]);
        // Make a request to set IsFocusedInboxCapable if IsFocusedInboxEnabled is set to true
        if (isFocusedInboxEnabled) {
            setIsFocusedCapableService_1.setIsFocusedInboxCapableService();
        }
    }
    updateAlwaysInCacheTableIds_1.default();
});
//# sourceMappingURL=setFocusedInboxOnOff.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-focused-inbox-config/lib/actions/setFocusedInboxOnOff.js
// module id = 4638
// module chunks = 56